import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { DocumentWithProjectUser } from '../Document/documentSlice';
import { getRotateEquipmentListWithDocuments } from '../../../api/rotate-equipment-lists';

export const getRotateEquipmentAccessoryWithDocumentsAsync = createAsyncThunk(
  'rotateEquipmentLists/getRotateEquipmentListWithDocuments',
  getRotateEquipmentListWithDocuments
);

export interface RotateEquipmentListWithDocument {
  id: number;
  name: string;
  partNo: string;
  isCustomName: boolean;
  rotateEquipmentListGroupId: number;
  documents: DocumentWithProjectUser[];
}

interface RotateEquipmentListState {
  templateWithDocument: RotateEquipmentListWithDocument[];
}

const initialState: RotateEquipmentListState = {
  templateWithDocument: []
};

export default createSlice({
  name: 'rotateEquipmentLists',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getRotateEquipmentAccessoryWithDocumentsAsync.fulfilled,
      (state, action) => {
        state.templateWithDocument = action.payload.data;
      }
    );
  }
});
